import {json} from '../core/data-source/json.mapper';

export class UISettingsRecord {
    @json({
        jsonName: 'LANG',
        value: 'EN',
        mapper: {
            from: (value: string) => value.toLowerCase()
        }
    })
    language: string;

    @json() title: string;

    carrotQuestEnabled: boolean;

    @json({
        jsonName: 'rc.site_key'
    })
    rcSiteKey: string;

    @json()
    account: string;

    @json({
        jsonName: 'ga.trackingId'
    })
    gaTrackingId: string;
}
